import { camelCase } from 'lodash';
const maxIterations = 3;
export function getStyleProp(el, styleProp, css, index = 0) {
    if (el && index < maxIterations) {
        return (getFromInlineStyle(el, styleProp) ||
            getPropFromClassDefinition(el.attr('class'), css, styleProp) ||
            getStyleProp(getParent(el), styleProp, css, ++index));
    }
}
function getFromInlineStyle(el, styleProp) {
    if (el && el.attr('style')) {
        return el.css(styleProp);
    }
    return null;
}
function getParent(el) {
    return el.parent();
}
function getPropFromClassDefinition(classNames, css, styleProp) {
    return (classNames || '').split(' ').reduce((property, currentClass) => {
        if (!property && currentClass.includes('so-global')) {
            return (css[currentClass] || {})[camelCase(styleProp)];
        }
        return property;
    }, '');
}
//# sourceMappingURL=css-property-utils.js.map